import React from 'react'

const SPIN_STYLE = `@keyframes ekkam-load-more-spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`

interface LoadMoreButtonProps {
  onClick: () => void
  loading: boolean
  remaining?: number
  style?: React.CSSProperties
  className?: string
}

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  onClick,
  loading,
  remaining,
  style,
  className,
}) => (
  <button
    onClick={onClick}
    disabled={loading}
    className={className}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.4rem',
      padding: '0.45rem 1.25rem',
      background: 'transparent',
      border: '1px solid var(--border)',
      borderRadius: '8px',
      color: 'var(--text-muted)',
      fontSize: '0.8rem',
      fontWeight: 500,
      cursor: loading ? 'not-allowed' : 'pointer',
      transition: 'border-color 0.15s, color 0.15s',
      opacity: loading ? 0.7 : 1,
      ...style,
    }}
    onMouseEnter={e => { if (!loading) { (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(124,58,237,0.4)'; (e.currentTarget as HTMLButtonElement).style.color = 'var(--text-primary)' } }}
    onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.borderColor = 'var(--border)'; (e.currentTarget as HTMLButtonElement).style.color = 'var(--text-muted)' }}
  >
    <style>{SPIN_STYLE}</style>
    {loading ? (
      <>
        <span style={{ display: 'inline-block', width: 10, height: 10, border: '1.5px solid var(--border)', borderTopColor: 'var(--accent-primary)', borderRadius: '50%', animation: 'ekkam-load-more-spin 0.7s linear infinite', flexShrink: 0 }} />
        Loading...
      </>
    ) : (
      remaining !== undefined ? `Load more (${remaining} more)` : 'Load more'
    )}
  </button>
)
